import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NotificationService } from './notification.service';
import { JwtHelperService } from '@auth0/angular-jwt';

import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BaseJwtService {
  protected api: string = environment.apiUrl + '/api';

  constructor(
    protected _http: HttpClient,
    protected _notificationService: NotificationService,
    protected _jwtHelper: JwtHelperService,
    protected _router: Router
    ) {}

    // Para peticiones con el JWT
  protected httpOptionsJwt() {
    const token = localStorage.getItem('jwt');
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    };
    return httpOptions;
  }

  // Para el envío de archivos
  protected httpOptionsFilesJwt() {
    const token = localStorage.getItem('jwt');
    const httpOptionsFiles = {
      headers: new HttpHeaders({
        enctype: 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      })
    };

    return httpOptionsFiles;
  }

  esUsuarioAutenticadoJWT() {
    const token = localStorage.getItem('jwt');
    return !this._jwtHelper.isTokenExpired(token);
  }


  logoutAspirante(){
    localStorage.clear();
    this._router.navigate(['aspirante/login']);
  }


}
